var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXdcYoutubeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98844 9.58611V3.9743C9.98064 4.91173 11.5236 5.8173 13.3485 6.79363C11.8433 7.62834 9.98064 8.56491 7.98844 9.58611ZM19.091 1.18328C18.7474 0.730524 18.1616 0.378089 17.5381 0.261409C15.7053 -0.0866411 4.27099 -0.0876311 2.43915 0.261409C1.93911 0.355149 1.49384 0.581732 1.11133 0.933772C-0.500362 2.42967 0.00466618 10.4517 0.393147 11.7512C0.556507 12.3136 0.76769 12.7193 1.03365 12.9855C1.37631 13.3376 1.84547 13.58 2.38436 13.6887C3.89345 14.0008 11.668 14.1753 17.5062 13.7355C18.0441 13.6418 18.5202 13.3916 18.8958 13.0246C20.3859 11.5347 20.2843 3.06213 19.091 1.18328Z",
    fill: "#717184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdcYoutubeIcon);
export default __webpack_public_path__ + "static/media/xdc-youtube-icon.dddc88b447cf5e59cea0dbc9c9bae4d3.svg";
export { ForwardRef as ReactComponent };